import * as React from 'react'

import {type ConsoleAgentT} from '@frontrow/console/src/helpers/auth-helpers'

// Pass a nonsensical default value so that when we actually
// authenticate, consumers never have to check if it's null
const AgentContext: React.Context<ConsoleAgentT> = React.createContext({
  email: '',
  verified: false,
  groups: []
} as ConsoleAgentT)

AgentContext.displayName = 'AgentContext'

export default AgentContext
